export const SHOPPING_LIST_COOKIE_KEY = 'shoppingList';
export const COMPARE_LISTS_LIMIT_DEFAULT = 10;
export const COMPARE_LIST_LIMIT_DEFAULT = 10;

export const BASKET_LOAD = 'basket:load';
export const BASKET_DELETE_PRODUCTS = 'basket:delete_products';
export const BASKET_SET_PRODUCT = 'basket:set_product';
export const BASKET_UPDATE = 'basket:update';

export const LABELS_GA_NAMES = {
  PIM: 'onlineOnly',
  BPR: 'bestPrice',
  LOF: 'offerLimited',
  STD: 'discount',
};
export const DATA_QA_DISCOUNT_PERCENT_PLATE = 'discountPercentPlate';
export const DATA_QA_PRODUCT_BEST_PRICE_NAMEPLATE = 'product-best-price-nameplate';

export const DEFAULT_CARD_WIDTH = 280;

export const SET_PRODUCT_CATEGORY = 'COMPO';

export const enum LogLevel {
  Info = 'info',
  Error = 'error',
}
